/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `CO_WORKER` - Co-worker
 * * `PEER` - Peer
 * * `SUPERVISOR` - Supervisor
 * * `MANAGEMENT` - Management
 * * `FELLOWSHIP` - Fellowship
 * * `RESIDENCY` - Residency
 * * `MEDICAL_SCHOOL` - Medical School
 * * `OTHER` - Other
 */
export enum RelationshipTypeEnum {
    CO_WORKER = 'CO_WORKER',
    PEER = 'PEER',
    SUPERVISOR = 'SUPERVISOR',
    MANAGEMENT = 'MANAGEMENT',
    FELLOWSHIP = 'FELLOWSHIP',
    RESIDENCY = 'RESIDENCY',
    MEDICAL_SCHOOL = 'MEDICAL_SCHOOL',
    OTHER = 'OTHER',
}
